import { Component, inject, signal } from '@angular/core';
import { GeneralHeaderComponent } from '@app/framework/general-header/general-header.component';
import { TabSelectorButtonComponent } from '@app/framework/buttons/tab-selector-button/tab-selector-button.component';
import { ContactsListingComponent } from '@app/pages/webapp/contacts/contacts-listing/contacts-listing.component';
import { InvitationsListingComponent } from '@app/pages/webapp/contacts/invitations-listing/invitations-listing.component';
import { SearchInputComponent } from '@app/framework/search-input/search-input.component';
import { ContactsStore } from '@app/store/contacts/contacts.store';
import { InvitationsStore } from '@app/store/invitations/invitations.store';

type ContactTab = 'contacts' | 'invitations';

@Component({
  selector: 'app-contacts',
  imports: [
    GeneralHeaderComponent,
    TabSelectorButtonComponent,
    ContactsListingComponent,
    InvitationsListingComponent,
    SearchInputComponent,
  ],
  templateUrl: './contacts.component.html',
  styleUrl: './contacts.component.scss',
})
export class ContactsComponent {
  contactsStore = inject(ContactsStore);
  invitationsStore = inject(InvitationsStore);

  selectedTab = signal<ContactTab>('contacts');

  setActiveTab(tab: ContactTab) {
    this.selectedTab.set(tab);
  }

  onSearchChange(text: string) {
    if (this.selectedTab() === 'contacts') {
      this.contactsStore.setSearchText(text);
    } else {
      this.invitationsStore.setSearchText(text);
    }
  }
}
